import loadable from '@loadable/component';

export const BuilderCallReasonsContainerLoadable = loadable(() => import('./BuilderCallReasonsContainer'));
